export const range = (min:number, max:number) => {
	let x = Math.random() * (max - min) + min;
	return Math.trunc(x);
}